/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Embark
 * @since   1.0.0
 */

/**
 * Polyfills for features not supported by all browsers.
 *
 * @since 1.0.1
 */
import './modules/theme/polyfills';

/**
 * Font-loading with 'fontfaceobserver'.
 *
 * @since 1.0.0
 */
import './modules/theme/webfonts';

/**
 * Lazy-load images with 'vanilla-lazyload',
 * and initialize picturefill after they've loaded.
 *
 * @since 1.0.0
 */
import './modules/theme/images';

/**
 * Add classes to image and video thumbnail links, and setup
 * click events to open the image/video in a Colorbox modal.
 *
 * @since 1.0.0
 */
import './modules/theme/lightboxes';

/**
 * Make file inputs and select elements easier to style.
 *
 * @since 1.0.0
 */
import './modules/theme/forms';

/**
 * Scroll to hash on click. Scroll to hash on load.
 *
 * @since 1.0.0
 */
import './modules/theme/scroll-to';

/**
 * Toggle 'scrolled' class on sticky header.
 *
 * @since 1.0.0
 */
import './modules/theme/sticky-header';

/**
 * Toggle 'scrolled' class on sticky header.
 *
 * @since 1.0.0
 */
import './modules/theme/main-menu';

/**
 * Spotlight slider.
 *
 * @since 1.0.0
 */
import './modules/theme/block-spotlight-slider';

/**
 * Comment Reply
 *
 * @since 1.0.0
 */
import './modules/theme/comment-reply';

/**
 * Masthead
 *
 * @since 1.0.0
 */
import './modules/theme/masthead';

/**
 * Header Search
 *
 * @since 1.0.0
 */
import './modules/theme/header-search';

/**
 * Tables
 *
 * @since 1.0.0
 */
import './modules/theme/table';

/**
 * Parallax
 *
 * @since 1.0.0
 */
import './modules/theme/parallax';

/**
 * Job Links
 *
 * @since 1.0.0
 */
import './modules/theme/job-links';

/**
 * HP Masthead Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp-masthead-slider';

/**
 * HP Resource Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp-resource-slider';

/**
 * HP Benefit Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp-benefit-slider';

/**
 * HP Rollover cols accoridons
 *
 * @since 1.0.0
 */
import './modules/theme/hp-rollover-cols';

/**
 * HP Rollover cards accoridons
 *
 * @since 1.0.0
 */
// import './modules/theme/hp-rollover-cards';

/**
 * Post type filters
 *
 * @since 1.0.0
 */
import './modules/theme/post-type-filters.js';

/**
 * Nav Buttons
 *
 * @since 1.0.0
 *
 * Note: this logic is not used in redesign Header (September 2023)
 */
// import './modules/theme/nav-buttons.js';

/**
 * Speedbump
 *
 * @since 1.0.0
 */
import './modules/theme/speedbump.js';

/**
 * Navigator
 *
 * @since 1.0.0
 */
import './modules/theme/navigator.js';

/**
 * Hover Intent
 *
 * @since 1.0.0
 */
import './modules/theme/hoverIntent.js';

/**
 * Read More
 *
 * @since 1.0.0
 */
import './modules/theme/read-more.js';

/**
 * HP2 Testimonial Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp2-testimonial-slider.js';

/**
 * HP2 Listing Posts Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp2-listing-posts-slider.js';

/**
 * HP2 Listing Videos Slider
 *
 * @since 1.0.0
 */
import './modules/theme/hp2-listing-videos-slider.js';

/**
 * Tooltips
 *
 * @since 1.0.0
 */
import './modules/theme/tooltips.js';

/**
 * HP2 Hexagons
 *
 * @since 1.0.0
 */
import './modules/theme/hp2-hexagons.js';

/**
 * Navigation Table of Content
 */
import './modules/theme/nav-table-of-content.js';

/**
 * Site Notices
 */
import './modules/theme/site-notice.js';
